export default __webpack_public_path__ + "static/media/Ever-spinning Gearwheel.eeb73760.png";